import { z } from 'zod'

import { StringDtoSchema } from '@hcr/api/shared'

export const HoldingNotVisibleDtoSchema = z.strictObject({
  imageUrl: StringDtoSchema,
  title: StringDtoSchema,
  ingress: StringDtoSchema,
  ctaText: StringDtoSchema,
  content: StringDtoSchema,
})

export type HoldingNotVisibleDto = z.infer<typeof HoldingNotVisibleDtoSchema>
